export const PUBLIC_CONFIG_KEYS = {
  apiUrl: "API_URL",
  discordUrl: "DISCORD_URL",
  youtubeUrl: "YOUTUBE_URL",
  twitterUrl: "TWITTER_URL",
  telegramUrl: "TELEGRAM_URL",
};

const ALL_PUBLIC_CONFIG_KEYS = Object.values(PUBLIC_CONFIG_KEYS);
const REQUIRED_PUBLIC_CONFIG_KEYS = [PUBLIC_CONFIG_KEYS.apiUrl];

let publicConfigPromise;
let publicConfigCache;

const validatePublicConfig = (config) => {
  if (!config || typeof config !== "object" || Array.isArray(config)) {
    throw new Error("Runtime config must be a JSON object.");
  }

  const normalizedConfig = { ...config };

  for (const key of ALL_PUBLIC_CONFIG_KEYS) {
    const value = normalizedConfig[key];

    if (value == null) {
      continue;
    }

    if (typeof value !== "string") {
      throw new Error(`Runtime config value must be a string: ${key}`);
    }

    normalizedConfig[key] = value.trim();
  }

  for (const key of REQUIRED_PUBLIC_CONFIG_KEYS) {
    if (!normalizedConfig[key]) {
      throw new Error(`Missing required runtime config: ${key}`);
    }
  }

  return Object.freeze(normalizedConfig);
};

export const loadPublicConfig = async () => {
  if (publicConfigCache) {
    return publicConfigCache;
  }

  if (!publicConfigPromise) {
    publicConfigPromise = fetch("/config.json", { cache: "no-store" })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to load runtime config: ${response.status} ${response.statusText}`,
          );
        }

        return response.json();
      })
      .then((config) => {
        publicConfigCache = validatePublicConfig(config);
        return publicConfigCache;
      })
      .catch((error) => {
        publicConfigPromise = undefined;
        throw error;
      });
  }

  return publicConfigPromise;
};

export const getOptionalPublicConfigValue = async (key) => {
  const config = await loadPublicConfig();
  return typeof config?.[key] === "string" ? config[key] : null;
};

export const getRequiredPublicConfigValue = async (key) => {
  const value = await getOptionalPublicConfigValue(key);

  if (!value) {
    throw new Error(`Missing required runtime config: ${key}`);
  }

  return value;
};
